<script setup lang="ts">
import { ref } from 'vue'
import ListContact from '../components/ListContact.vue'
const phone = ref('')
const email = ref('')

const isJSONValid = (str: string) => {
  try {
    JSON.parse(str)
  } catch (e) {
    return false
  }
  return true
}

window.addEventListener('message', function (event) {
  console.log(`Chatwoot event`, event)
  if (!isJSONValid(event.data)) {
    return;
  }

  const eventData = JSON.parse(event.data);
  const phoneNumber = eventData?.data?.contact?.phone_number
  const emailAddress = eventData?.data?.contact?.email

  if (emailAddress) {
    console.log(`Found email`, emailAddress)
    email.value = emailAddress
  }

  if (phoneNumber) {
    phone.value = phoneNumber.replace(/\D/g, '')
    console.log(`Found number`, phone.value)
  }
});

window.parent.postMessage('chatwoot-dashboard-app:fetch-info', '*')
</script>

<template>
  <ListContact v-if="phone" :phone="phone" :email="email"/>
  <div v-else>
    Aguardando receber o número de telefone do chatwoot...
  </div>
</template>
